// src/components/SearchForm/components/PopulationFilters.tsx
import React from 'react';
import { POPULATION_DATA } from '../../../shared/population-colors';

interface PopulationFiltersProps {
  populationFilter: string[];
  onPopulationChange: (name: string) => void;
}

const PopulationFilters: React.FC<PopulationFiltersProps> = ({
  populationFilter,
  onPopulationChange,
}) => {
  const populationData = Object.values(POPULATION_DATA);

  return (
    <div className="grid grid-cols-2 md:flex md:flex-wrap w-fit m-auto justify-center items-center md:justify-between p-2 md:py-4 md:px-2 pb-0 gap-1 md:w-full">
      {populationData.map((population) => (
        <button
          key={population.name}
          onClick={() => onPopulationChange(population.name)}
          className="flex md:flex-col text-start items-center md:justify-center md:text-center text-sm p-1 md:p-2 rounded-lg w-40 md:w-[120px] hover:scale-110 transition-transform"
          style={{
            borderColor: populationFilter.includes(population.name) ? population.color : "transparent",
            borderWidth: 2,
            borderStyle: "solid",
            backgroundColor: populationFilter.includes(population.name) ? "#f2f2f2" : "white",
          }}
        >
          <div className="rounded-full p-2 custom-population-icon" style={{ backgroundColor: population.color }}>
            <img src={`/assets/images/${population.icon}`} alt={`${population.name} Icon`} className="svg-icon svg-icon-white" />
          </div>
          <span className="w-[88px] md:w-26 mt-0 ml-2 md:ml-0 md:mt-2 text-[11px] md:text-[13px]">
            {population.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default PopulationFilters;